export default __webpack_public_path__ + "static/pair-with-puzzels-e391aece39e16718ffdcef212c9b961f.svg";